import { Gift } from 'lucide-react';
import { MARKETING_CONSENT_BONUS } from './MarketingConsentFields';

interface MarketingBonusNudgeProps {
  onAccept: () => void;
  onDecline: () => void;
  busy?: boolean;
}

/** Second chance shown when a member leaves marketing consent incomplete. */
export function MarketingBonusNudge({ onAccept, onDecline, busy = false }: MarketingBonusNudgeProps) {
  return (
    <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center bg-black/40 p-4">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="marketing-bonus-nudge-title"
        className="w-full max-w-sm rounded-2xl bg-white p-6 text-center shadow-2xl"
      >
        <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-amber-100">
          <Gift className="h-6 w-6 text-amber-600" />
        </div>
        <h2 id="marketing-bonus-nudge-title" className="text-lg font-extrabold text-forest-900">
          지금 동의하면 {MARKETING_CONSENT_BONUS}포인트를 드려요
        </h2>
        <p className="mt-2 text-sm text-forest-600">
          문자·이메일로 신기능 출시, 라이브 설명회, 무료 포인트 이벤트 소식을 받아보세요. 언제든 회원정보에서 끌 수 있어요.
        </p>
        <button
          type="button"
          onClick={onAccept}
          disabled={busy}
          className="mt-5 w-full rounded-xl bg-gradient-to-r from-amber-500 to-amber-600 py-3 text-sm font-bold text-white shadow-md disabled:opacity-50"
        >
          모두 동의하고 {MARKETING_CONSENT_BONUS}포인트 받기
        </button>
        <button
          type="button"
          onClick={onDecline}
          disabled={busy}
          className="mt-2 w-full rounded-xl py-2.5 text-sm font-medium text-forest-500 hover:bg-forest-50 disabled:opacity-50"
        >
          괜찮아요, 받지 않을게요
        </button>
      </div>
    </div>
  );
}
